import { createSlotRecipe } from './runtime.js';

const textAreaConfig = {"name":"textArea","slots":["root","textAreaContainer","textArea","endAdornment"],"defaultVariants":{"error":false,"hasEndAdornment":false,"size":"md","success":false,"warning":false},"variantMap":{"error":["true"],"hasEndAdornment":["true"],"size":["lg","md","sm","xl"],"success":["true"],"warning":["true"]}}

export const textArea = /* @__PURE__ */ createSlotRecipe(textAreaConfig)